export enum PurchaseType {
  DEALER = 'DEALER',
  PRIVATE_PARTY = 'PRIVATE_PARTY',
}
